import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"


export class RepeatOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'order/repeatOrder',
      requesterInfo,
    })
  }

  public async repeatOrder(request: string): Promise<any> {
    return await this.postAsync<any>(JSON.stringify(request))
  }
}
